// Типы для игры Музыкальное Лото

export interface Track {
  number: number;
  file: string;
  artist: string;
  title: string;
  startTime?: number; // Время начала воспроизведения в секундах (для пропуска вступления)
}

export interface GamePackage {
  id: string;
  name: string;
  description: string;
  tracks: Track[];
  settings?: GameSettings; // Настройки игры для этого пакета
}

export interface GameSettings {
  defaultPlayDuration: number; // Длительность воспроизведения по умолчанию в секундах
  infoDisplayDelay: number; // Задержка перед показом информации в секундах
}

/** Снимок игровой сессии с сервера. */
export interface SessionState {
  package: GamePackage | null;
  numberToTrackMap: Record<string, Track>;
  settings: GameSettings;
  playedNumbers: number[];
  currentTrack: Track | null;
  isPlaying: boolean;
  showInfo: boolean;
  isContinued: boolean;
  pausedTrack: Track | null;
  pausedAt: number | null;
  hidePlayed: boolean;
  displayConnected: boolean;
  playFrom: number | null;
  playAt: number | null;
  serverNow: number;
  audioNonce: number;
}

export const defaultSettings: GameSettings = {
  defaultPlayDuration: 15,
  infoDisplayDelay: 5,
};

/** Пустая клиентская сессия до ответа сервера. */
export function emptySession(): SessionState {
  return {
    package: null,
    numberToTrackMap: {},
    settings: defaultSettings,
    playedNumbers: [],
    currentTrack: null,
    isPlaying: false,
    showInfo: false,
    isContinued: false,
    pausedTrack: null,
    pausedAt: null,
    hidePlayed: false,
    displayConnected: false,
    playFrom: null,
    playAt: null,
    serverNow: 0,
    audioNonce: 0,
  };
}

export type ClientRole = 'display' | 'dj';

export interface GameState {
  currentPackage: GamePackage | null;
  settings: GameSettings;
  playedNumbers: Set<number>;
  currentTrack: Track | null;
  isPlaying: boolean;
  showInfo: boolean;
  playStartTime: number | null;
  isContinued: boolean; // Флаг продолжения трека (играет до конца)
  stopTimerId: number | null; // ID таймера для остановки трека
  numberToTrackMap: Map<number, Track>; // Карта номеров к трекам (после перемешивания)
  isFullscreen: boolean; // Флаг полноэкранного режима
}

